export const exploreIdeasListKeys = {
  all: ['explore', 'ideas-list'] as const,
  page: (listSignature: string, page: number) =>
    [
      ...exploreIdeasListKeys.all,
      'page',
      listSignature,
      page,
    ] as const,
};

export function buildExploreIdeasListSignature(ideaIds: string[]): string {
  return ideaIds.join('|');
}
